<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4">
    <div class="flex justify-center">
      <div class="flex-shrink-0">
        <ExclamationIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ExclamationIcon } from "@heroicons/vue/solid";

interface Props {
  title?: string;
}

defineProps<Props>();
</script>
